{
	"title": "Notifications",
	"empty": "No notifications",
	"emptyHint": "When AI finishes processing or reminders trigger — they'll show up here.",
	"markAllRead": "Mark all as read",
	"markRead": "Mark as read",
	"markUnread": "Mark as unread",
	"delete": "Delete",
	"settings": "Notification settings",
	"openDetail": "Open",
	"unreadOnly": "Unread only",
	"unreadCount": "{count, plural, one {# unread} other {# unread}}",
	"loadMore": "Load more",
	"loading": "Loading…",
	"errorTitle": "Failed to load notifications",
	"retry": "Retry",
	"filters": {
		"all": "All",
		"ai": "AI",
		"billing": "Billing",
		"streak": "Streak",
		"system": "System"
	},
	"groups": {
		"today": "Today",
		"yesterday": "Yesterday",
		"thisWeek": "This week",
		"earlier": "Earlier"
	},
	"actions": {
		"menu": "Notification actions",
		"close": "Close panel"
	},
	"categories": {
		"ai_task_complete": "AI task",
		"study_reminder": "Reminder",
		"system_alert": "System",
		"access_granted": "Access",
		"subscription_alert": "Subscription",
		"security_alert": "Security"
	},
	"aggregated": {
		"title": "{count, plural, one {# new artifact} other {# new artifacts}}",
		"expand": "Expand",
		"collapse": "Collapse"
	},
	"types": {
		"materialReady": "Material ready",
		"notesReady": "Note ready",
		"flashcardsReady": "Flashcards ready",
		"quizReady": "Quiz ready",
		"essayGraded": "Essay graded",
		"srsReminder": "Time to review",
		"streakAtRisk": "Streak at risk",
		"examSoon": "Exam coming up",
		"subscriptionRenewed": "Subscription renewed",
		"subscriptionExpired": "Subscription expired",
		"quotaWarning": "Approaching plan limit"
	},
	"channels": {
		"inApp": "In-app",
		"email": "Email",
		"push": "Push"
	},
	"detail": {
		"back": "Back to notifications",
		"openArtifact": "Open",
		"context": "Related to",
		"createdAt": "Created",
		"notFound": "Notification not found or deleted."
	},
	"pushPermission": {
		"title": "Enable push notifications?",
		"subtitle": "We'll ping you when AI finishes processing and when it's time to review. You can disable this in settings.",
		"allow": "Allow",
		"later": "Later",
		"enabled": "Push notifications enabled",
		"deniedHint": "Permission denied. You can enable it in your browser settings."
	},
	"pushUpdate": {
		"message": "To receive push notifications, update the StudyHub app to the latest version.",
		"action": "Update"
	},
	"disclaimer": {
		"titles": {
			"chat": "AI chat — use with judgment",
			"generation": "AI generation — verify sources",
			"essay": "Essay grading — a guide, not a verdict",
			"visuals": "Image recognition — may be imperfect",
			"notes": "AI notes are grounded in your material",
			"web-search": "Web search — external sources"
		},
		"body": "AI can be wrong or hallucinate. Always verify against the source material, especially for important decisions.",
		"dontShowAgain": "Don't show again",
		"gotIt": "Got it",
		"openTerms": "Terms and AI disclaimer"
	},
	"toast": {
		"marked": "Marked as read",
		"deleted": "Notification deleted",
		"undo": "Undo",
		"allRead": "All notifications marked read",
		"open": "Open"
	}
}
